<template>
  <div>
    <el-card shadow="always">
      <el-row :gutter="5">
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <el-page-header
            title
            @back="$router.push({ name: 'orderservices' })"
            :content="$t('solicitar-ordem-servico')"
          ></el-page-header>
        </el-col>
        <el-col
          :xs="24"
          :sm="24"
          :md="24"
          :lg="12"
          :xl="12"
          v-if="user.type === '1' || user.type === '3'"
        >
          <CustomerList
            v-if="user.type !== '5'"
            v-model="ruleForm.customer"
            v-bind:current="ruleForm.customer"
            v-on:selected="fetchCustomer"
          />
        </el-col>
      </el-row>
    </el-card>
    <el-card>
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-position="top"
        :status-icon="true"
        :inline-message="true"
      >
        <el-row :gutter="5">
          <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
            <el-form-item
              :label="$t('filial')"
              prop="branch"
              v-if="user.type === '2'"
            >
              <CustomerList
                v-model="ruleForm.branch"
                v-bind:current="ruleForm.branch"
                v-on:selected="fetchCustomer"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="10" :md="10" :lg="8" :xl="8">
            <el-form-item :label="$t('departamento')" prop="department">
              <DepartmentList
                v-model="ruleForm.department"
                v-bind:current="ruleForm.department"
                :customer="ruleForm.branch || ruleForm.customer"
              />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="10" :md="10" :lg="8" :xl="8">
            <el-form-item :label="$t('solicitante')" prop="requester" required>
              <el-input v-model="ruleForm.requester"></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="10" :md="10" :lg="8" :xl="8">
            <el-form-item :label="'Motorista'" prop="driver">
              <DriversList
                v-model="ruleForm.driver"
                :current="ruleForm.driver"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item :label="$t('observacao')" prop="observation">
              <el-input
                v-model="ruleForm.observation"
                type="textarea"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span>{{ $t("prepostagem") }}</span>
          </div>
          <div>
            <el-row :gutter="10" class="prepost-filters">
              <el-col :xs="24" :sm="12" :md="10" :lg="8" :xl="6">
                <el-date-picker
                  v-model="range"
                  type="daterange"
                  align="right"
                  unlink-panels
                  clearable
                  range-separator="à"
                  format="dd/MM/yyyy"
                  start-placeholder="Inicio"
                  end-placeholder="Fim"
                  style="width: 100%"
                  @change="fetchPrepost"
                ></el-date-picker>
              </el-col>
              <el-col :xs="24" :sm="12" :md="10" :lg="8" :xl="6">
                <el-input
                  :placeholder="$t('pesquisar')"
                  prefix-icon="el-icon-search"
                  v-model="filter"
                  clearable
                ></el-input>
              </el-col>
            </el-row>
            <el-table
              :data="tableDataFilter"
              stripe
              size="mini"
              height="400"
              ref="tablePrepost"
              @selection-change="handleSelectionChange"
              :default-sort="{ prop: 'sourcezipcode', order: 'ascending' }"
            >
                <el-table-column type="selection" width="60"></el-table-column>
                <el-table-column
                  sortable
                  prop="cardpost"
                  label="Cartão"
                ></el-table-column>
                <el-table-column
                  sortable
                  prop="destinyzipcode"
                  label="Destino"
                ></el-table-column>
                <el-table-column
                  sortable
                  prop="destinyname"
                  label="Dest. Nome"
                ></el-table-column>
                <el-table-column
                  sortable
                  prop="tag"
                  :label="$t('objeto')"
                ></el-table-column>
                <el-table-column prop="service" :label="$t('servico')">
                </el-table-column>
                <el-table-column
                  sortable
                  prop="pricetable"
                  :label="$t('valor')"
                >
                  <template slot-scope="scope">
                    {{
                      scope.row.pricetable
                        | currency("R$ ", 2, {
                          thousandsSeparator: ".",
                          decimalSeparator: ",",
                        })
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  sortable
                  prop="invoice"
                  label="NF"
                ></el-table-column>
                <el-table-column sortable prop="createdAt" :label="$t('data')">
                  <template slot-scope="scope">
                    {{ scope.row.createdAt | formatDate }}
                  </template>
                </el-table-column>
            </el-table>
          </div>
        </el-card>

        <el-card
          class="box-card"
          shadow="never"
          v-if="totalSelecionado > 0"
        >
          <div slot="header" class="clearfix">
            <span>{{ $t("quantidade-servico") }}</span>
          </div>
          <div>
            <el-badge
              v-for="record of servicosSelecionados"
              v-bind:key="record.code"
              :value="record.selection"
              type="primary"
              class="item"
            >
              <el-tag type="info">{{ record.name }}</el-tag>
            </el-badge>
            <el-badge :value="totalSelecionado" type="warning" class="item">
              <el-tag>Total</el-tag>
            </el-badge>
          </div>
        </el-card>
        <br />
        <el-form-item style="text-align: center">
          <el-button
            type="warning"
            autofocus
            @click="submitForm('ruleForm')"
            >Enviar O.S.</el-button
          >
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import { OrderServicesService } from "@/services/customers/order.services.services";
import { PrepostService } from "@/services/customers/prepost.services";
import { UserService } from "@/services/users/user.services";
import { RouteService } from "@/services/umov/route.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import DepartmentList from "@/xpost/views/register/department/DepartmentList.vue";
import DriversList from "./Components/DriversList.vue";
import moment from "moment";
import "moment/locale/pt-br";

export default {
  name: "OrderServices",
  components: {
    CustomerList,
    DepartmentList,
    DriversList,
  },
  methods: {
    fetchCustomer() {
      this.fetchPrepost();
      this.getDriver();
    },
    fetchRecords() {
      const vm = this;
      const groupBy = vm.tableData.reduce(
        (cnt, cur) => (
          (cnt[cur.serviceCode] = {
            selection: 0,
            code: cur.serviceCode,
            name: cur.service,
          }),
          cnt
        ),
        {}
      );
      vm.tableServices = [];
      for (const key in groupBy) {
        vm.tableServices.push(groupBy[key]);
      }
    },

    fetchPrepost() {
      const vm = this;
      if (!vm.ruleForm.customer) {
        return false;
      }
      // sem intervalo (limpo pelo usuário) busca tudo, como antes
      let startedAt = null;
      let finishedAt = null;
      if (vm.range && vm.range[0] && vm.range[1]) {
        startedAt = moment(vm.range[0]).format("YYYY-MM-DD");
        finishedAt = moment(vm.range[1]).format("YYYY-MM-DD");
      }
      const loading = vm.$loading(vm.$options.loading);
      PrepostService.orderservices(
        vm.ruleForm.branch || vm.ruleForm.customer,
        startedAt,
        finishedAt
      )
        .then((response) => {
          vm.tableData = response.records;
          vm.fetchRecords();
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },

    getDriver() {
      if (!this.ruleForm.customer) {
        return false;
      }
      const loading = this.$loading(this.$options.loading);

      RouteService.findByCustomer(
        this.ruleForm.branch || this.ruleForm.customer
      )
        .then((response) => {
          this.ruleForm.driver = response;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },

    submitForm(formName) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);

      const data = {
        observation: vm.ruleForm.observation,
        colection: vm.ruleForm.coleta,
        requester: vm.ruleForm.requester,
        customer: vm.ruleForm.customer,
        departament: vm.ruleForm.department,
        prepost: vm.$refs.tablePrepost.selection,
        driver_id: vm.ruleForm.driver,
        plp: vm.ruleForm.plp,
        plp_number: vm.ruleForm.plp_number,
      };

      OrderServicesService.add(data)
        .then(() => {
          this.$message({
            type: "success",
            message: "Ordem de Serviço adicionada com sucesso!",
          });
          vm.$router.push({ name: "orderservices" });
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },

    handleSelectionChange(data, index) {
      const vm = this;
      const map = data.reduce(function (prev, cur) {
        prev[cur.serviceCode] = (prev[cur.serviceCode] || 0) + 1;
        return prev;
      }, {});
      for (const row of vm.tableServices) {
        row.selection = 0;
      }
      for (const key in map) {
        const service = vm.tableServices.filter((x) => x.code === key);
        if (service.length > 0) {
          service[0].selection = map[key];
        }
      }
    },
  },
  computed: {
    servicosSelecionados() {
      return this.tableServices.filter((record) => record.selection > 0);
    },
    totalSelecionado() {
      return this.tableServices.reduce(
        (total, record) => total + record.selection,
        0
      );
    },
    tableDataFilter() {
      const vm = this;
      const term = vm.filter.trim().toLowerCase();
      if (!term) {
        return vm.tableData;
      }
      return vm.tableData.filter((data) =>
        [
          data.tag,
          data.destinyname,
          data.destinyzipcode,
          data.sourcezipcode,
          data.service,
          data.cardpost,
          data.invoice,
        ].some((value) => (value || "").toString().toLowerCase().includes(term))
      );
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
        if (vm.user.type === "2" || vm.user.type === "5") {
          vm.ruleForm.customer = response.customers.id;
          vm.getDriver();
        }
        vm.fetchPrepost();
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
  data() {
    return {
      filter: "",
      range: [new Date().setDate(new Date().getDate() - 7), new Date()],
      user: {
        type: "5",
      },
      tableServices: [],
      tableData: [],
      qtyServices: [],
      ruleForm: {
        department: "",
        coleta: true,
        observation: "",
        requester: "",
        customer: "",
        branch: "",
        driver: undefined,
        plp: null,
        plp_number: null,
      },
    };
  },
};
</script>
<style>
.right {
  float: right;
}

.label {
  font-weight: bold;
}

.item {
  margin-top: 0px;
  margin-right: 40px;
}

.prepost-filters {
  margin-bottom: 10px;
}

.box-card {
  margin-top: 14px;
}
</style>

